<template>
  <v-tab-item :value="$route.path" class="pa-3">
    <v-container fluid class="b-container">
      <v-sheet class="pa-3" style="overflow: auto" outlined>
        <v-row no-gutters align="center" class="pa-5 pt-0">
          <v-col cols="auto">
            <v-img src="@/assets/gift-catalog.png" width="60" height="60"></v-img>
          </v-col>

          <v-col cols="7" class="pl-5">
            <h4 v-text="translations.title[lang]"></h4>
            <div style="font-size: 0.875rem" class="font-weight-medium mt-1">
              {{ translations.info[lang] }}
            </div>
          </v-col>
        </v-row>

        <v-toolbar flat>
          <v-btn
            v-if="getPermission('gifts.create')"
            color="secondary"
            class="text-capitalize"
            depressed
            v-text="translations.addGift[lang]"
            @click="openGiftDialog('create', {})"
          ></v-btn>
        </v-toolbar>

        <v-toolbar flat>
          <v-spacer></v-spacer>

          <v-col cols="12" sm="4" class="pa-0">
            <b-search-field v-model="search"></b-search-field>
          </v-col>
        </v-toolbar>
        <v-sheet min-width="1200">
          <v-data-table
            :headers="headers"
            :items="gifts"
            :footer-props="{
              itemsPerPageOptions: [12],
              showCurrentPage: true,
              pageText: `${page * 12 - 11}-${
                page * 12 <= serverItemsLength ? page * 12 : serverItemsLength
              } ${translations.paginationText[lang]} ${serverItemsLength}`,
            }"
            :page.sync="page"
            :loading="loading"
            :server-items-length="serverItemsLength"
            class="b-outlined"
            disable-sort
          >
            <template v-slot:item.title="{ item }">
              {{ makeTextShorter(item.title) }}
            </template>
            <template v-slot:item.description="{ item }">
              {{ makeTextShorter(item.description) }}
            </template>
            <template v-slot:item.supplier="{ item }">
              <span v-if="getPermission('gifts.supplier.read')">
                {{ (item.supplier && item.supplier.name) || '-' }}</span
              >
              <span v-else>-</span>
            </template>
            <template v-slot:item.image="{ item }">
              <v-img :src="item.image" width="70" v-if="item.image"></v-img>
              <div v-else>-</div>
            </template>
            <template v-slot:item.show_on_catalog="{ item }">
              {{ item.show_on_catalog ? 'Visible' : 'Not visible' }}
            </template>

            <template v-if="getPermission('gift.update')" v-slot:item.actions="{ item }">
              <v-tooltip color="secondary" top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="yellow darken-3"
                    icon
                    v-on="on"
                    @click="openGiftDialog('update', item)"
                  >
                    <v-icon v-text="icons.mdiPencilOutline"></v-icon>
                  </v-btn>
                </template>

                <span class="font-weight-bold" v-text="translations.update[lang]"></span>
              </v-tooltip>

              <v-tooltip v-if="getPermission('gift.delete')" color="secondary" top>
                <template v-slot:activator="{ on }">
                  <v-btn color="red" icon v-on="on" @click="openDeleteDialog(item.gift_id)">
                    <v-icon v-text="icons.mdiClose"></v-icon>
                  </v-btn>
                </template>

                <span class="font-weight-bold" v-text="translations.delete[lang]"></span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-sheet>

        <v-dialog
          v-model="giftFormDialog"
          :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '40%'"
        >
          <GiftForm :mode="mode" @close="giftFormDialog = false" />
        </v-dialog>

        <v-dialog v-model="supplierDialog" max-width="400">
          <SupplierForm @cancel="supplierDialog = false" />
        </v-dialog>

        <v-dialog v-model="deleteDialog" max-width="500">
          <b-card
            type="delete"
            :title="translations.deleteModalTitle[lang]"
            :submit-text="{
              el: 'Διαγραφή',
              en: 'delete',
              it: 'Elimina',
            }"
            @cancel="deleteDialog = false"
            @submit="remove"
          >
            <div class="subtitle-1 font-weight-medium py-3">
              {{ translations.deleteModalText[lang] }}
              <span class="font-weight-bold text--primary">Gift</span>?
            </div>
          </b-card>
        </v-dialog>
      </v-sheet>
    </v-container>
  </v-tab-item>
</template>

<script>
import { mdiMagnify, mdiChevronDown, mdiPencilOutline, mdiClose, mdiPlus } from '@mdi/js';

import { mapMutations, mapState, mapActions } from 'vuex';

import GiftForm from '@/components/loyaltyPanel/giftCatalog/GiftForm';
import SupplierForm from '@/components/loyaltyPanel/giftCatalog/SupplierForm';
import translations from '@/utils/translations/loyaltyPanel/giftCatalog';
import debounce from 'lodash/debounce';

export default {
  name: 'GiftCatalog',
  components: { GiftForm, SupplierForm },

  mixins: [translations],

  data() {
    return {
      icons: {
        mdiMagnify,
        mdiChevronDown,
        mdiPencilOutline,
        mdiClose,
        mdiPlus,
      },
      mode: 'create',
      itemsPerPageOptions: [10, 25, 50, 100],
      menu: false,
      search: '',
      supplierDialog: false,
      deletingGiftId: null,
      page: +this.$route.query.page,
      giftFormDialog: false,
    };
  },

  computed: {
    ...mapState(['loading', 'errorMessage', 'serverItemsLength']),

    lang() {
      return this.$route.params.lang;
    },
    gifts: {
      get() {
        return this.$store.state.loyaltyPanel.catalogManagement.gifts;
      },
    },

    deleteDialog: {
      get() {
        return this.$store.state.deleteDialog;
      },

      set(val) {
        this.setDeleteDialog(val);
      },
    },

    query() {
      let query = '?';

      for (let key in this.$route.query) {
        query += `${key}=${this.$route.query[key]}&`;
      }

      return query.slice(0, query.length - 1);
    },

    headers() {
      return [
        {
          text: this.translations.image[this.lang],
          value: 'image',
        },
        {
          text: this.translations.name[this.lang],
          value: 'title',
        },
        {
          text: this.translations.description[this.lang],
          value: 'description',
        },
        {
          text: this.translations.code[this.lang],
          value: 'product_code',
        },
        {
          text: this.translations.catalogCode[this.lang],
          value: 'printed_catalog_code',
        },
        {
          text: this.translations.cost[this.lang],
          value: 'cost',
        },
        {
          text: this.translations.supplier[this.lang],
          value: 'supplier',
        },
        {
          text: this.translations.category[this.lang],
          value: `gift_category.name[${this.lang}]`,
        },

        {
          text: this.translations.type[this.lang],
          value: `gift_type.name[${this.lang}]`,
        },
        {
          text: this.translations.points[this.lang],
          value: 'points',
        },
        {
          text: this.translations.visibleToCustomer[this.lang],
          value: 'show_on_catalog',
        },
        {
          text: this.translations.couponId[this.lang],
          value: 'coupon_id',
        },
        {
          text: this.translations.actions[this.lang],
          value: 'actions',
        },
      ];
    },
  },

  watch: {
    search(val) {
      if (!val) {
        this.getGifts(this.query);
      } else {
        this.debouncedSearch();
      }
    },
    $route(val) {
      if (!val.query.page) {
        this.$router.push({
          query: {
            page: 1,
            ...this.$route.query,
          },
        });
      }
      this.getGifts(`${this.query}&q=${this.search}`);
    },

    page(page) {
      this.$router.push({ query: { ...this.$route.query, page } });
    },
  },

  methods: {
    ...mapMutations('loyaltyPanel/catalogManagement', ['setGift']),
    ...mapMutations(['setDialog', 'setDeleteDialog', 'setResetSuccess', 'setResetValidation']),
    ...mapActions(['getPermission']),
    ...mapActions('loyaltyPanel/catalogManagement', ['getGifts', 'delete', 'getGiftData']),

    openGiftDialog(mode, item) {
      this.mode = mode;
      if (mode === 'update') {
        item.supplier_store_id = item.supplier ? item.supplier.store_id : null;
        item.gift_category_id = item.gift_category.gift_category_id;
        item.gift_type_id = item.gift_type.gift_type_id;
      }
      this.setGift(item);

      this.giftFormDialog = true;
      setTimeout(() => this.setResetSuccess(true), 300);
      this.setResetValidation(true);
    },

    handleSearch() {
      if (this.page != 1) {
        this.page = 1;
      } else {
        this.getGifts(`?q=${this.search}`);
      }
    },

    openDeleteDialog(id) {
      this.deletingGiftId = id;
      this.deleteDialog = true;
    },

    async remove() {
      await this.delete(this.deletingGiftId);
      this.deleteDialog = false;
      this.deletingGiftId = null;
    },

    makeTextShorter(text) {
      if (text && text.length > 30) {
        text = text.substring(0, 30) + ' ...';
      }
      return text;
    },
  },

  created() {
    this.debouncedSearch = debounce(this.handleSearch, 500);
  },

  mounted() {
    this.getGifts(this.query);
  },

  beforeCreate() {
    if (!this.$route.query.page) {
      this.$router.push({
        query: {
          page: 1,
          ...this.$route.query,
        },
      });
    }
  },
};
</script>
